import { useMutation } from '@tanstack/react-query'

import { requestSyncCardTransactionsToFreeeForAccounting } from '@src/api'
import { DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRequestSyncCardTransactionsToFreeeForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest
    ) => requestSyncCardTransactionsToFreeeForAccounting(axiosInstance, params),
  })
}
